import React, { createContext, useContext, useState } from 'react';

const TimeRangeContext = createContext();

export const TimeRangeProvider = ({ children }) => {
  const [timeRange, setTimeRange] = useState('24h');

  return (
    <TimeRangeContext.Provider value={{ timeRange, setTimeRange }}>
      {children}
    </TimeRangeContext.Provider>
  );
};

export const useTimeRange = () => {
  const context = useContext(TimeRangeContext);

  if (context === undefined) {
    throw new Error('useTimeRange must be used within a TimeRangeProvider');
  }

  return context;
};
